import React from 'react';
import { Link } from 'react-router-dom';
import { SACRAMENT_IMAGES } from '../data/mock';
import EditableText from '../components/EditableText';

const DEFAULT_BODY = [
  'The Church accompanies the faithful from birth to death and beyond. Catholic funeral rites offer worship, praise, and thanksgiving to God for the gift of a life which has now been returned to Him.',
  'When a loved one passes away, please contact the parish office as soon as possible. Our pastor and staff will guide you compassionately through the planning of the funeral liturgy.',
  'We encourage all parishioners to pre-plan their funeral wishes, which is a great gift to your family. Resources are available through the parish office.'
].join('\n\n');

const FuneralPlanning = () => {
  return (
    <>
      {/* Hero */}
      <section className="relative h-[42vh] md:h-[52vh] overflow-hidden" data-testid="funeral-hero">
        <img
          src={SACRAMENT_IMAGES.funeral}
          alt="Funeral Planning"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2a1a45]/30 to-[#2a1a45]/85" />
        <div className="relative z-10 h-full flex flex-col items-center justify-end text-center pb-14 px-6">
          <h1 className="font-display text-5xl md:text-7xl text-white">Funeral Planning</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-16">
        <blockquote className="border-l-2 border-[#a68a5b] pl-6 py-2 my-8">
          <p className="font-display text-2xl md:text-3xl text-[#2a1a45] italic leading-snug">
            &ldquo;I am the resurrection and the life. Whoever believes in me, though he die, yet shall he live.&rdquo;
          </p>
          <cite className="block mt-3 text-sm text-[#5a534a] not-italic">&mdash; John 11:25</cite>
        </blockquote>

        <div className="prose max-w-none" data-testid="funeral-body">
          <EditableText
            contentKey="funeral_planning_body"
            label="Funeral Planning — Body Text"
            rows={14}
            defaultValue={DEFAULT_BODY}
            paragraphClass="text-[15px] md:text-base text-[#3f3a34] leading-[1.85]"
          />
        </div>

        <div className="mt-12 bg-[#f2ead6]/60 border border-[#e9e0cc] p-8 text-center" data-testid="funeral-next-steps">
          <h3 className="font-display text-2xl text-[#2a1a45] mb-3">Next Steps</h3>
          <p className="text-sm text-[#5a534a] mb-5">
            Contact the parish office so we can begin planning with your family through the funeral liturgy.
          </p>
          <Link
            to="/contact"
            className="inline-block px-5 py-2.5 bg-[#3a2359] text-white text-sm hover:bg-[#4d2f75]"
            data-testid="funeral-contact-btn"
          >
            Contact the Parish Office
          </Link>
        </div>
      </section>
    </>
  );
};

export default FuneralPlanning;
